import type { IconData } from '@stacksjs/iconify-core'

export const phoneSignalFull: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.955 3.81h-3.05v1.52h1.52v21.33h-1.52v1.53h3.05v-1.53h1.52V5.33h-1.52z\"/><path fill=\"currentColor\" d=\"M24.385 5.33h1.52v21.33h-1.52Zm-3.05 3.05h-3.05V9.9h1.52v16.76h-1.52v1.53h3.05v-1.53h1.52V9.9h-1.52zm-4.57 1.52h1.52v16.76h-1.52Zm-3.05 3.05h-3.05v1.52h1.53v12.19h-1.53v1.53h3.05v-1.53h1.52V14.47h-1.52zm-4.57 1.52h1.52v12.19h-1.52Zm-3.05 3.05h-3.05v1.52h1.53v7.62h-1.53v1.53h3.05v-1.53h1.52v-7.62h-1.52zm-4.57 1.52h1.52v7.62h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default phoneSignalFull
